import React from 'react'

import Head from 'next/head'

import ClientErrorBoundary from '@/components/error/ClientErrorBoundary'
import { getLayout } from '@/components/layouts/sbir/Layout'
import { SearchContextProvider } from '@/components/search/context'
import Search from '@/components/search/Sbir/Search'
import { getMetadataFn } from '@/components/seo/DefaultMetadata'

import { requireAuth } from '@/helpers/auth'

import { useSbirSearchStore } from '@/stores/SbirSearchStore'

import type { NextPageWithLayout } from '@/types/next'

const SbirSearchPage: NextPageWithLayout = () => {
  const store = useSbirSearchStore()

  return (
    <>
      <Head>
        <title>SBIR/STTR Search - Sweetspot</title>
      </Head>
      <ClientErrorBoundary>
        <SearchContextProvider type="sbir" store={store}>
          <Search />
        </SearchContextProvider>
      </ClientErrorBoundary>
    </>
  )
}

SbirSearchPage.getLayout = getLayout
SbirSearchPage.getMetadata = getMetadataFn({
  title: 'SBIR/STTR Opportunities on Sweetspot',
  description:
    'Search for SBIR/STTR opportunities using Sweetspot AI. Sweetspot helps you find and win government funding faster than ever before.',
})

export default requireAuth(SbirSearchPage)
